//Mapa para un Market
function initialize(x,y,titulo,imagen,direccion) {
			
    var coorX = x,
        coorY = y,
        tituloInf = titulo,
        imgInf = imagen,
        dirInf = direccion;
			
	var myCenter = new google.maps.LatLng(coorX,coorY)
	
    var mapProp = {
	center:myCenter,
    zoom:16,
	scrollwheel: false,
    mapTypeId:google.maps.MapTypeId.ROADMAP,
        
  styles :[
    {
        "featureType": "all",
        "elementType": "geometry.fill",
        "stylers": [
            {
                "gamma": "5.58"
            },
            {
                "color": "#aae7e7"
            },
            {
                "saturation": "77"
            },
            {
                "lightness": "-8"
            },
            {
                "weight": "3.41"
            }
        ]
    },
    {
        "featureType": "administrative.province",
        "elementType": "all",
        "stylers": [
            {
                "visibility": "off"
            }
        ]
    },
    {
        "featureType": "administrative.province",
        "elementType": "geometry.stroke",
        "stylers": [
            {
                "color": "#ff0000"
            }
        ]
    },
    {
        "featureType": "administrative.neighborhood",
        "elementType": "geometry.fill",
        "stylers": [
            {
                "color": "#ff0000"
            }
        ]
    },
    {
        "featureType": "administrative.land_parcel",
        "elementType": "geometry.fill",
        "stylers": [
            {
                "saturation": "10"
            },
            {
                "invert_lightness": true
            }
        ]
    },
    {
        "featureType": "landscape",
        "elementType": "all",
        "stylers": [
            {
                "saturation": -100
            },
            {
                "lightness": 65
            },
            {
                "visibility": "on"
            }
        ]
    },
    {
        "featureType": "landscape.man_made",
        "elementType": "geometry.fill",
        "stylers": [
            {
                "saturation": "-93"
            },
            {
                "lightness": "37"
            }
        ]
    },
    {
        "featureType": "landscape.natural",
        "elementType": "geometry.stroke",
        "stylers": [
            {
                "color": "#ff0000"
            }
        ]
    },
    {
        "featureType": "poi",
        "elementType": "all",
        "stylers": [
            {
                "saturation": -100
            },
            {
                "lightness": 51
            },
            {
                "visibility": "simplified"
            }
        ]
    },
    {
        "featureType": "poi.park",
        "elementType": "geometry.fill",
        "stylers": [
            {
                "color": "#bfcacc"
            }
        ]
    },
    {
        "featureType": "road.highway",
        "elementType": "all",
        "stylers": [
            {
                "saturation": -100
            },
            {
                "visibility": "simplified"
            }
        ]
    },
    {
        "featureType": "road.highway",
        "elementType": "geometry.fill",
        "stylers": [
            {
                "color": "#d7dedf"
            }
        ]
    },
    {
        "featureType": "road.arterial",
        "elementType": "all",
        "stylers": [
            {
                "saturation": -100
            },
            {
                "lightness": 30
            },
            {
                "visibility": "on"
            }
        ]
    },
    {
        "featureType": "road.arterial",
        "elementType": "geometry.fill",
        "stylers": [
            {
                "color": "#fffafa"
            }
        ]
    },
    {
        "featureType": "road.local",
        "elementType": "all",
        "stylers": [
            {
                "saturation": -100
            },
            {
                "lightness": 40
            },
            {
                "visibility": "on"
            }
        ]
    },
    {
        "featureType": "road.local",
        "elementType": "geometry.fill",
        "stylers": [
            {
                "color": "#ffffff"
            }
        ]
    },
    {
        "featureType": "transit",
        "elementType": "all",
        "stylers": [
            {
                "saturation": -100
            },
            {
                "visibility": "simplified"
            }
        ]
    },
    {
        "featureType": "transit",
        "elementType": "geometry.fill",
        "stylers": [
            {
                "visibility": "on"
            }
        ]
    },
    {
        "featureType": "water",
        "elementType": "geometry",
        "stylers": [
            {
                "hue": "#eaf6f8"
            },
        ]
    },
    {
        "featureType": "water",
        "elementType": "labels",
        "stylers": [
            {
                "visibility": "on"
            },
            {
                "lightness": -25
            },
            {
                "saturation": -100
            }
        ]
    }
]
 
  };
  var map = new google.maps.Map(document.getElementById("map"),mapProp);
  
var marker=new google.maps.Marker({
  position:myCenter,
  animation:google.maps.Animation.DROP,
  icon:'/images/iconos/market.png',
  });

marker.setMap(map);
    
// InfoWindow content
    
var infoWcont = '<div class="infoWindows">'+
                  '<div class="imagen">'+'<img src="'+imgInf+'"></div>'+
                  '<div class="direccion">'+
                      '<h5>'+tituloInf+'</h5>'
                      +'<p>'+dirInf+'</p>'
                  +'</div>'
              +'</div>';
    

var infowindow = new google.maps.InfoWindow({
  content:infoWcont,
  });

google.maps.event.addDomListener(marker, 'click', function() {
  infowindow.open(map,marker);
  });
 
// infowindow.open(map,marker);

}//








